function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  y: -0.253,
  width: 283.463,
  height: 283.465
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M181.055,50.69H89.506c-14.037,0-25.456,11.419-25.456,25.455v113.679c0,13.879,11.167,25.191,24.986,25.443 c-1.313,4.095-4.696,10.988-13.224,15.953c0,0,22.582,7.155,29.654-15.941h75.588c14.037,0,25.456-11.419,25.456-25.455V76.145 C206.511,62.109,195.092,50.69,181.055,50.69z M112.863,184.752H86.991v-25.877h25.872V184.752z M112.863,145.723H86.991v-25.876 h25.872V145.723z M112.863,106.693H86.991V80.817h25.872V106.693z M150.178,145.723h-25.873v-25.876h25.873V145.723z  M150.178,106.693h-25.873V80.817h25.873V106.693z M187.491,145.723h-25.872v-25.876h25.872V145.723z"
});

function SvgBildmeddelande(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.46px",
    height: "283.46px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBildmeddelande);
export default __webpack_public_path__ + "static/media/bildmeddelande.01e9c32b.svg";
export { ForwardRef as ReactComponent };